import CheckBox from 'devextreme-react/check-box';
import DataGrid, { Column } from 'devextreme-react/data-grid';
import React, { useEffect, useReducer, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { khoanNopGroupApi } from '../../../../api/sf_khoannop_group_api';
import {
	saleSetRegisterDichVuApi
} from '../../../../api/sf_saleset_register_dichvu_api';
import { PrimaryButton } from '../../../../components/editor/button';
import { useCommonContext } from '../../../../contexts/common';
import { showNotify } from '../../../../helpers/toast';

const DanhSachDichVu = ({ ts_hocsinh_id, namHocSelected, height, onSuccess, onCancel }) => {
	const iniState = {
		khoannop_groups: [],
		khoannop_groups_by_hocsinh: [],
		selected_khoannop_group: {},
	};
	const actionTypes = {
		SET_KHOANNOP_GROUPS_BY_HOCSINH: 'SET_KHOANNOP_GROUPS_BY_HOCSINH',
		SET_SELECTED_KHOANNOP_GROUP: 'SET_SELECTED_KHOANNOP_GROUP',
	};
	const reducer = (state, action) => {
		switch (action.type) {
			case actionTypes.SET_KHOANNOP_GROUPS_BY_HOCSINH:
				return {
					...state,
					khoannop_groups_by_hocsinh: action.payload,
				};
			case actionTypes.SET_SELECTED_KHOANNOP_GROUP:
				return {
					...state,
					selected_khoannop_group: action.payload,
				};
			default:
				return state;
		}
	};
	const [isLoading, setIsLoading] = useState(false);
	const [isSaving, setIsSaving] = useState(false);
	const { canAccessTo, translate } = useCommonContext();
	const { register, trigger, errors } = useForm();
	const grid = useRef(null);
	const [state, dispatch] = useReducer(reducer, iniState);
	// const { nam_hoc } = useSelector(x => x.namHoc);
	const { dm_coso_id } = useSelector((x) => x.coSo);

	useEffect(() => {
		if (namHocSelected != '') {
			handleReloadKhoanNopGroupByHocSinh();
		}
	}, [namHocSelected, ts_hocsinh_id, dm_coso_id]);
	useEffect(() => {
		if (isLoading) {
			grid.current.instance.beginCustomLoading();
		} else {
			grid.current.instance.endCustomLoading();
		}
	}, [isLoading]);
	const handleReloadKhoanNopGroupByHocSinh = async () => {
		// if (canAccessTo(MON_THI_API_END_POINT, HttpMethod.GET)) {
		setIsLoading(true);
		const res = await khoanNopGroupApi.SelectByHocSinh({
			ts_hocsinh_id: ts_hocsinh_id,
			dm_coso_id: dm_coso_id,
			nam_hoc: namHocSelected,
		});
		setIsLoading(false);
		if (res.is_success) {
			// res.data = res.data.filter((x) => x.nam_hoc == namHocSelected);
			dispatch({ type: actionTypes.SET_KHOANNOP_GROUPS_BY_HOCSINH, payload: res.data });
		}
		// }
	};
	const handleSaveChanges = async (datas) => {
		trigger().then(async (isValid) => {
			if (isValid) {
				setIsSaving(true);
				var dataInsert = {
					list_khoannop_group: state.khoannop_groups_by_hocsinh,
					// list_so_thang_su_dung_by_group_id: state.khoannop_groups.map(obj => obj.so_thang_su_dung),
					ts_hocsinh_id: ts_hocsinh_id,
					nam_hoc: namHocSelected,
				};
				const res = await saleSetRegisterDichVuApi.InsertMultiple(dataInsert);
				setIsSaving(false);
				if (res.is_success) {
					showNotify({ text: translate('Cập nhật thành công '), type: 'success' });
					handleReloadKhoanNopGroupByHocSinh();
				} else {
					showNotify({ text: res.message, type: 'error' });
				}
			}
		});
	};
	const cellRender = (data) => {
		return (
			<div>
				{/* {canAccessTo(MON_THI_API_END_POINT, HttpMethod.PUT) && ( */}
				<span style={{ cursor: 'pointer' }} onClick={() => { }}>
					<CheckBox
						defaultValue={data.data.is_checked}
						onValueChanged={(e) => {
							// if (e.value == true) {
							//     state.khoannop_groups_by_hocsinh.push(data.data)
							// } else {
							//     state.khoannop_groups_by_hocsinh = state.khoannop_groups_by_hocsinh.filter(function (item) {
							//         return item.sf_khoannop_group_id !== data.data.sf_khoannop_group_id
							//     })
							// }
							const new_state = state.khoannop_groups_by_hocsinh.map((x) => {
								if (x.sf_khoannop_group_id != data.data.sf_khoannop_group_id) {
									return x;
								} else {
									return { ...x, is_checked: e.value };
								}
							});
							dispatch({ type: actionTypes.SET_KHOANNOP_GROUPS_BY_HOCSINH, payload: new_state });
						}}
					></CheckBox>
				</span>
				{/* )} */}
			</div>
		);
	};
	// const so_thang_su_dung_setCellValue = (newData, value, currentRowData) => {
	//     const listKhoanNops = state.khoannop_groups_by_hocsinh;
	//     const new_state = listKhoanNops.map(x => {
	//         if (currentRowData.is_checked == true) {
	//             if (x.sf_khoannop_group_id != currentRowData.sf_khoannop_group_id) {
	//                 return x;
	//             } else {
	//                 return { ...x, so_thang_su_dung: value }
	//             }
	//         } else {
	//             {
	//                 return x;
	//             }
	//         }
	//     })
	//     dispatch({ type: actionTypes.SET_KHOANNOP_GROUPS_BY_HOCSINH, payload: new_state })
	// }
	return (
		<div>
			<div className='row'>
				<div className='col-md-12'>
					<DataGrid
						noDataText={translate('Không có dữ liệu')}
						ref={grid}
						grid={grid}
						keyExpr='sf_khoannop_group_id'
						dataSource={state.khoannop_groups_by_hocsinh}
						columnHidingEnabled={false}
						columnAutoWidth={true}
						showBorders={true}
						showColumnLines={true}
						showRowLines={true}
						rowAlternationEnabled={true}
						allowColumnResizing={true}
						columnResizingMode={'nextColumn'}
						hoverStateEnabled={true}
						focusedRowEnabled={false}
						wordWrapEnabled
						height={height ? height-300 : window.innerHeight - 400}
					>
						<Column
							visibleIndex={0}
							caption={'#'}
							cellRender={(cell) => <span>{cell.rowIndex + 1}</span>}
							width={40}
							alignment='center'
						/>
						<Column alignment='center' caption={translate('Thao tác')} cellRender={cellRender} width={85}></Column>,
						<Column key={1} dataField='ten_khoan_nop_group' caption={translate('Tên khoản nộp')}></Column>,
						{/* <Column
                                            alignment='left'
                                            dataField="so_thang_su_dung"
                                            caption="Số tháng sử dụng"
                                            width={120}
                                            setCellValue={so_thang_su_dung_setCellValue}
                                            allowEditing={true}
                                        /> */}
					</DataGrid>
				</div>
				<div className='col-md-12 padding-top-1rem'>
					<div>
						<PrimaryButton text={'Cập nhật'} onClick={handleSaveChanges} isLoading={isSaving} />
					</div>
				</div>
			</div>
		</div>
	);
};
export default DanhSachDichVu;
